import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ChevronRightIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M8.755 6 15 12l-6.245 6-.612-.588L13.775 12 8.143 6.588 8.755 6Z"
      />
    </svg>
  </IconWrapper>
));
